export default __webpack_public_path__ + "static/media/rocks.f0e1c27c.mp3";